import { Toasts } from '@fourthwall/components'
import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import type { ApiError } from '@fourthwall/services/dist/types'
import { errorMessageSelector } from '@fourthwall/utils/dist/selectors'
import { useMutation } from '@tanstack/react-query'

export const useDeleteWelcomePostsMutation = () => {
  const deleteWelcomePostsMutation = useMutation({
    mutationFn: async () => {
      const { data } = await MembershipsCreatorApiClient.deleteWelcomePosts()

      return data
    },
    onError: (error: ApiError) => {
      const errorMessage = errorMessageSelector(error.response?.data)

      Toasts.notify(errorMessage, { type: 'error' })
    },
  })

  return { deleteWelcomePostsMutation }
}
